jQuery(document).ready(function($) {
  $('.qty-opts').on('click', function (e) {
    $('.qty-opts').removeClass('active');
    $(this).addClass('active');
	 e.preventDefault();
     var a = $(this);
	 var b = $(this).data('pro-qty');
    $('#quantity').val(b);  
    var c = $('.rc-radio--active').find("input[name='purchaseOption']:checked").val();
    purchase(c);
    var d = $(this).data('size');
    $('input[data-radio="' + d + '"]').trigger('click');
  });

  
  $(document).on('change', '#quantity', function () {
        var b = parseInt($(this).val()); 
        var c = $('.rc-radio--active').find("input[name='purchaseOption']:checked").val();
  if (b === 1) { inputChanger(b,c) } 
  else if (b === 2) { inputChanger(b,c)   } 
  else if (b === 3) {inputChanger(b,c)   } 
  else {
    var m = 3
    inputChanger(m,c)   } 

    
  });
  
  $(document).on('change', 'input[type=radio][name=purchaseOption]', function () {
   var a = $('.rc-radio--active').find("input[name='purchaseOption']:checked").val(); 
   $('.beep').each(function() {
           var m = $(this).data('size');
           var p = $('#'+m).data(a+'-price');
          $(this).text('$' + p);
        });
  purchase(a);
     
  });

function purchase (a) {
  var m = $('.qty-opts.active').data(a+'-price');
   $('#product_price_block_new').text('$'+m);
}
  function inputChanger (b,c) {
    $('.qty-opts').removeClass('active');
    $('div[data-pro-qty="' + b + '"]').addClass('active');
     purchase(c);
}
});